import RestApi, { awarenessEventServiceBaseUrl, hospitalServiceBaseUrl } from '../config/api_config'

export default {
  data () {
    return {
      assistiveDeviceList: [],
      disabilityTypeList: []
    }
  },
  computed: {
    hasDropdownLoadedAwarenessEvent () {
      return this.$store.state.AwarenessEventService.commonObj.hasDropdownLoaded
    }
  },
  watch: {
    hasDropdownLoadedAwarenessEvent: function (newValue) {
      if (!newValue) {
        this.loadDropdownAwarenessEventService()
      }
    }
  },
  created () {
    this.getAssistiveDeviceList()
    this.getDisabilityTypeList()
    const hasDropdownLoadedAwarenessEvent = this.$store.state.AwarenessEventService.hasDropdownLoaded
    if (!hasDropdownLoadedAwarenessEvent || window.performance) {
    }
    this.loadDropdownAwarenessEventService()
  },
  methods: {
    async getAssistiveDeviceList () {
      const result = await RestApi.getData(hospitalServiceBaseUrl, '/configuration/disability-type/assistive-device-list')
      this.assistiveDeviceList = result.success ? result.data : []
    },
    async getDisabilityTypeList () {
      const result = await RestApi.getData(hospitalServiceBaseUrl, '/configuration/disability-type/list-all')
      this.disabilityTypeList = result.success ? result.data : []
    },
    async loadDropdownAwarenessEventService () {
      const result = await RestApi.getData(hospitalServiceBaseUrl, '/configuration/disability-type/list-all')
      const disabilityTypeList = result.success ? result.data : []
      const response = await RestApi.getData(hospitalServiceBaseUrl, '/consultancy-therapy-center/therapy-center/list-all')
      const idscCenterList = response.success ? response.data : []
      await RestApi.getData(awarenessEventServiceBaseUrl, 'common-dropdowns', null).then(response => {
        if (response.success) {
          this.$store.dispatch('AwarenessEventService/mutateCommonObj', {
            hasDropdownLoaded: true,
            serviceTypeList: response.data.serviceTypeList,
            eventTypeList: response.data.eventTypeList,
            eventList: response.data.eventList,
            serviceProcessStepList: response.data.serviceProcessStepList,
            fairStallList: response.data.fairStallList,
            patientCategoryList: response.data.patientCategoryList,
            stallTypeList: response.data.stallTypeList,
            disabilityTypeList: disabilityTypeList,
            patientList: response.data.patientList,
            stallList: response.data.stallList,
            employerList: response.data.employerList,
            assistiveDeviceList: this.assistiveDeviceList,
            supplierInfoList: response.data.supplierInfoList,
            circularList: response.data.circularList,
            idscCenterList: idscCenterList,
            groupList: response.data.groupList,
            instituteList: response.data.instituteList,
            skillList: response.data.skillList,
            educationLevelList: response.data.educationLevelList,
            degreeList: response.data.degreeList
          })
          this.$store.dispatch('AwarenessEventService/localizeCommonDropdown', { value: this.$i18n.locale })
        }
      })
    }
  }
}
